import React, { Component } from 'react'
import ReactDOM from 'react-dom';


import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'

interface IComplectItem {
    entrNumber: number
    entrPrice: number
}


class ComplectItem extends Component<ReturnType<typeof storesToProps> & IComplectItem> {

    public state = { isOpen: false }

    public onChangeIsOpenHundler = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    public render() {
        const { entrsPlates, removeEntrPlates, removeEntrPlate } = this.props.busket
        const { entrNumber, entrPrice } = this.props

        return (

            <div className={`complect__li ${ this.state.isOpen ? "active" : "" }`} onClick={this.onChangeIsOpenHundler}>
                <div className="complect__title">
                    <span className="complect__num">Подъезд №{entrNumber + +1}</span>
                    <span className="complect__summ">{entrPrice}р.</span>
                </div>
                <ul className="complect__items">
                    {entrsPlates.filter(item => item.entranceNumber === entrNumber).map((plt, index) =>
                        <li className="complect__item">
                            <div className="complect__item__dopinfo">
                                <div className="complect__item__img">
                                    <img className="image" src={plt.img as string} />
                                    <span>{plt.size}</span>
                                </div>
                                <div className="complect__item__dopinfo">
                                    <div className="complect__item__name">{plt.name}</div>
                                    <div className="complect__item__val">{ }</div>
                                </div>
                                <div className="complect__item__close" onClick={(e) => {
                                    e.stopPropagation()
                                    removeEntrPlate(plt.id)
                                    }}>
                                    <img src="/local/templates/sign_plus/images/close.svg" />
                                </div>
                            </div>
                            <div className="complect__item__summdiv">
                                <div className="complect__item__price">{plt.price} руб/шт</div>
                                <div className="complect__item__quant">{plt.count} шт</div>
                                <div className="complect__item__summ">{plt.count * plt.price} руб.</div>
                            </div>
                        </li>)}
                </ul>
            </div>)
    }

}

const storesToProps = ({ store }: IStoresMap, _nextProps: IComplectItem) => ({
    busket: store.BusketStore,
})

export default connector(storesToProps)(ComplectItem)
